
import React, { createContext, useContext, useState, useCallback } from 'react';
import Toast from '../components/Toast';

const ToastContext = createContext();

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState(null);

    const showToast = useCallback((message, type = 'success', duration = 3000, isHtml = false) => {
        // If there's already a toast, clear it first to trigger the new one correctly
        setToast(null);
        setTimeout(() => {
            setToast({ message, type, duration, isHtml });
        }, 10);
    }, []);

    const hideToast = useCallback(() => {
        setToast(null);
    }, []);

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            {toast && (
                <Toast 
                    message={toast.message}
                    type={toast.type}
                    duration={toast.duration}
                    isHtml={toast.isHtml}
                    onClose={hideToast} 
                />
            )}
        </ToastContext.Provider>
    );
};
